import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">
            <i className="ri-home-4-line"></i>
            <span className="sr-only">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            {item.href ? (
              <Link to={item.href} className="text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-primary-400 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}